import React, { useState } from "react";
import "./EntitatsList.css";

// Importar las imágenes de todas las entidades
import arrancerdanyola from "../../../assets/images/entitats/ArranCerdanyola.jpg";
import cerdanyolaambpalestina from "../../../assets/images/entitats/CerdanyolaAmbPalestina.jpg";
import cgt from "../../../assets/images/entitats/CGT.jpg";
import collabastonera from "../../../assets/images/entitats/collaBastonera.jpg";
import cupcerdanyola from "../../../assets/images/entitats/CUPcerdanyola.png";
import elmistoteatre from "../../../assets/images/entitats/ElMistoTeatre.jpg";
import espaicreixent from "../../../assets/images/entitats/EspaiCreixent.jpg";
import fac from "../../../assets/images/entitats/FAC.jpg";
import guanyemcerdanyola from "../../../assets/images/entitats/GuanyemCerdanyola.png";
import lamartineta from "../../../assets/images/entitats/LaMartineta.jpg";
import lespurna from "../../../assets/images/entitats/L_Espurna.jpg";
import pahc from "../../../assets/images/entitats/PAHC.jpg";
import llogateres from "../../../assets/images/entitats/llogateres.jpg";
import ucfr from "../../../assets/images/entitats/UCFR.jpg";

const EntitatsList = () => {
  const [activeItem, setActiveItem] = useState(null);

  // Mapeo de imágenes a variables importadas
  const imageMap = {
    "ArranCerdanyola.jpg": arrancerdanyola,
    "CerdanyolaAmbPalestina.jpg": cerdanyolaambpalestina,
    "CGT.jpg": cgt,
    "collaBastonera.jpg": collabastonera,
    "CUPcerdanyola.png": cupcerdanyola,
    "ElMistoTeatre.jpg": elmistoteatre,
    "EspaiCreixent.jpg": espaicreixent,
    "FAC.jpg": fac,
    "GuanyemCerdanyola.png": guanyemcerdanyola,
    "LaMartineta.jpg": lamartineta,
    "L_Espurna.jpg": lespurna,
    "PAHC.jpg": pahc,
    "llogateres.jpg": llogateres,
    "UCFR.jpg": ucfr,
  };

  // Lista completa de entidades
  const entitatsData = [
    {
      id: 0,
      title: "Arran",
      description:
        "Arran Cerdanyola som el jovent revolucionari d'esquerres a Cerdanyola, lluitem per construir un nou món lliure, socialista, feminista i per l'autodeterminació dels pobles. Als Països Catalans, el jovent seguem arran! \n\nInsta: @arrancerdanyola\nX: @arransarda\nCorreu: cerdanyola@arran.cat\nReunions dimarts a la tarda, per saber horaris consultar al contacte",
      imageName: "ArranCerdanyola.jpg",
      alt: "Arran",
    },
    {
      id: 1,
      title: "Cerdanyola amb Palestina",
      description:
        "Som el comitè de solidaritat amb Palestina de Cerdanyola. Organitzem actes, projectem pel·lícules, recaptem diners i fem acció política en suport del poble palestí. Tenim assemblea oberta l'últim dimecres del mes a les 19:00 al Casal. També ens podeu contactar per Instagram: @cerdanyolaambpalestina \n\nAssemblea oberta cada 4t dimecres de mes a les 19h.",
      imageName: "CerdanyolaAmbPalestina.jpg",
      alt: "Cerdanyola amb Palestina",
    },
    {
      id: 2,
      title: "CGT - Comitè Residència Joan XXIII",
      description:
        "Som la secció Sindical de la CGT a la residència per a persones amb diversitat funcional Joan XXIII de Cerdanyola del Vallès. Les delegades al comitè d'empresa ens trobem cada dijous de 10 a 14 hores al Casal Popular de La Flama. \n\nTwitter: @CGTJoan23\nCorreu: comitejoanxxiii@gmail.com",
      imageName: "CGT.jpg",
      alt: "CGT - Comitè Residència Joan XXIII",
    },
    {
      id: 3,
      title: "Colla Bastonera de Cerdanyola del Vallès",
      description:
        "La Colla Bastonera de Cerdanyola del Vallès neix l'abril 2024 amb l'objectiu de recuperar i promoure el ball de bastons al municipi. Des del primer dia vam assajar i vam trobar suport total del Casal Popular La Flama, que a més és la nostra seu social. Som una colla inclusiva i integradora, on tothom hi és benvingut, independentment de l'experiència. \n\nAssagem els divendres de 17:15h a 19h i participem en cercaviles i trobades tant al poble com arreu de Catalunya. \n\nSi vols sumar-t'hi, ens pots escriure a collabastoneracerdanyola@gmail.com o seguir-nos a Instagram @collabastoneracerdanyola.",
      imageName: "collaBastonera.jpg",
      alt: "Colla Bastonera de Cerdanyola del Vallès",
    },
    {
      id: 4,
      title: "CUP Cerdanyola",
      description:
        "La Candidatura d'Unitat Popular som una organització política assembleària independentista i anticapitalista que partint de l'àmbit municipal, treballem per uns Països Catalans independents, socialistes, ecològicament sostenibles, territorialment equilibrats i no patriarcals. A Cerdanyola del Vallès, treballem el municipalisme de base a través de la candidatura Guanyem Cerdanyola. \n\nContacte: cerdanyola@cup.cat\nTwitter: @cupcerdanyola\nInstagram: @cupcerdanyola\nFacebook: CUP Cerdanyola del Vallès\nBluesky: @cupcerdanyola.bsky.social",
      imageName: "CUPcerdanyola.png",
      alt: "CUP Cerdanyola",
    },
    {
      id: 5,
      title: "El Misto Teatre",
      description:
        "Som una companyia de teatre amateur adreçada a joves adults. La nostra missió és fer un teatre inclusiu, amb obres de creació pròpia i tallers diversos. Un teatre accessible i divertit! \n\nPots posar-te en contacte amb nosaltres mitjançant el nostre Instagram @elmistoteatre. \n\nEns reunim cada dilluns i dimecres del mes de 20h a 22h al Casal Popular La Flama",
      imageName: "ElMistoTeatre.jpg",
      alt: "El Misto Teatre",
    },
    {
      id: 6,
      title: "Espai Creixent",
      description:
        "Som un grup de famílies que hem decidit ocupar l'espai públic amb les nostres criatures. Ens veiem tots els dilluns a la tarda i compartim inquietuds i experiències. No som professionals, no oferim cap servei, només fem xarxa entre nosaltres mentres els nostres petits també gaudeixen del joc i el moviment lliure. \n\nTots els dilluns de 17h a 19h.\nInstagram: ⁠@espaicreixent",
      imageName: "EspaiCreixent.jpg",
      alt: "Espai Creixent",
    },
    {
      id: 7,
      title: "Festes Alternatives de Cerdanyola - FAC",
      description:
        'Hola! Som les Festes Alternatives de Cerdanyola, i hem nascut per "liar-la parda" creant oci per les classes populars de Cerdanyola! Creiem que la festa és política i cal fer xarxa amb totes les entitats del poble per fer front a la festa consumista i pro-capitalista del nostre ajuntament. Festa sí, lluita també! \n\nAssemblees obertes cada dijous a les 19h\nContacte\nInsta: @facerdanyola\nCorreu: festesalternativescerdanyola@gmail.com\nX: @facerdanyola',
      imageName: "FAC.jpg",
      alt: "Festes Alternatives de Cerdanyola - FAC",
    },
    {
      id: 8,
      title: "Guanyem Cerdanyola",
      description:
        "Guanyem Cerdanyola som la candidatura municipalista que aglutina les diferents organitzacions i persones de l'esquerra alternativa de la ciutat. Compromís per Cerdanyola, la CUP, EUiA i altres organitzacions històriques treballen amb diferents persones de plataformes i entitats de la ciutat. Lluitem una Cerdanyola més justa socialment a través de promoure polítiques que beneficiïn la classe treballadora. \n\nTwitter: @CDVGuanyem\nFacebook: Guanyem Cerdanyola\nInstagram: @guanyemcerdanyola\nBluesky: .bsky.social ?",
      imageName: "GuanyemCerdanyola.png",
      alt: "Guanyem Cerdanyola",
    },
    {
      id: 9,
      title: "La Martineta, la Bèstia de Foc de Cerdanyola",
      description:
        "La Martineta és la Bèstia de Foc de Cerdanyola del Vallès, creada l'any 2005 per l'Associació La Verema amb l'objectiu de fomentar la cultura i les tradicions catalanes al municipi. Inspirada en un gat mesquer, la seva figura es caracteritza per un cos esvelt, una mirada ferotge i llengües de foc que dansen al seu voltant en cada actuació. Present a correfocs i festes populars, la Martineta encén els carrers amb el seu foc i la seva energia, portant l'esperit de la cultura del foc arreu on va. \n\nEns reunim l'últim dimecres de cada mes.\nContacte: martineta.cerdanyola@gmail.com\nInstagram: @martineta.cerdanyola",
      imageName: "LaMartineta.jpg",
      alt: "La Martineta, la Bèstia de Foc de Cerdanyola",
    },
    {
      id: 10,
      title: "L'Espurna",
      description:
        "L'Espurna som el col·lectiu feminista i anticapitalista de Cerdanyola, creiem que una nova realitat és possible amb la reivindicació desde la base, fins la victòria, no pararem. Visca la lluita feminista! \n\nReunions: dilluns a les 19h\nInsta: @lespurna_cerdanyola\nCorreu: lespurnacerdanyola@gmail.com",
      imageName: "L_Espurna.jpg",
      alt: "L'Espurna",
    },
    {
      id: 11,
      title: "PAHC Ripollet-Cerdanyola",
      description:
        "La PAHC (Plataforma d'Afectades per l'Habitatge i el Capitalisme) de Ripollet-Cerdanyola, és un espai de lluita anticapitalista, mogut per la solidaritat i el suport mutu, que agrupa activistes entorn de la problemàtica de l'habitatge. Ens organitzem de manera assembleària cada dimarts a les 18h. El 1r, 3r i 5è dimarts de cada mes ens trobem a Ripollet i el 2n i 4t a Cerdanyola. \n\nCorreu: ripolletpah@gmail.com\nX: @PAHCRipollet_Ce\nInstagram: @pahcripollet_cerdanyola\nFacebook: https://www.facebook.com/share/1Xqcg467sF/\nCanal Telegram: https://t.me/PAH_RipolletCerdanyola\nCanal WhatsApp: https://chat.whatsapp.com/JFDnC85Ucy62TwPpx0KLl7",
      imageName: "PAHC.jpg",
      alt: "PAHC Ripollet-Cerdanyola",
    },
    {
      id: 12,
      title: "Sindicat de Llogateres",
      description:
        "El Sindicat de Llogateres i Llogaters és una organització de persones que volem o ens ha tocat viure de lloguer a Catalunya i que ens unim per defensar el dret a un habitatge digne, estable i segur. La secció de Cerdanyola va néixer a principis de 2024 amb el mateix objectiu: mobilitzar i organitzar les veïnes de la ciutat per defensar el dret a l'habitatge i acabar amb els abusos de rendistes i immobiliàries. \n\nDies de reunió 1r i 3r dijous de cada mes a les 19:00, al Casal.\nContacte: @llogateres_cerdanyola\ncerdanyola@sindicatdellogateres.org",
      imageName: "llogateres.jpg",
      alt: "Sindicat de Llogateres",
    },
    {
      id: 13,
      title: "UCFR",
      description:
        "Grup local de Cerdanyola-Ripollet d'Unitat Contra el Feixisme i el Racisme. Moviment assembleari per combatre l'avenç de la ultradreta i els discursos d'odi. \n\nMail: ucfrcerdanyolaripollet@gmail.com\nX: @UCFRCerdanyola\nBluesky: @ucfrcerdanyola.bsky.social\nInstagram: ucfrcerdanyolaripollet",
      imageName: "UCFR.jpg",
      alt: "UCFR",
    },
  ];

  const toggleItem = (index) => {
    setActiveItem(activeItem === index ? null : index);
  };

  return (
    <section className="entitats-list">
      {entitatsData.map((entitat) => (
        <div
          key={entitat.id}
          className={`entitats-list__item ${
            activeItem === entitat.id ? "active" : ""
          }`}
          onClick={() => toggleItem(entitat.id)}
        >
          <div className="entitats-list__title">
            <h3>{entitat.title}</h3>
          </div>
          <p className="entitats-list__description">{entitat.description}</p>
          <img
            className="entitats-list__item-image"
            src={imageMap[entitat.imageName]}
            alt={entitat.alt}
          />
        </div>
      ))}
    </section>
  );
};

export default EntitatsList;
